// extracted by mini-css-extract-plugin
module.exports = {"itemWrap":"newsletter-signup-items_itemWrap__3R344","item":"newsletter-signup-items_item__81n4W","description":"newsletter-signup-items_description__Xwuk_"};